import React from 'react';

interface FadeProps {
  in: boolean;
  children: React.ReactNode;
  duration?: number; // Animation duration in milliseconds
}

function Fade({ in: inProp, children, duration = 300 }: FadeProps): JSX.Element {
  const fadeStyles = {
    entering: {
      opacity: 1,
      transition: `opacity ${duration}ms ease-in-out`,
    },
    exiting: {
      opacity: 0,
      transition: `opacity ${duration}ms ease-in-out`,
    },
  };

  return (
    <div
      style={{
        opacity: inProp ? fadeStyles.entering.opacity : fadeStyles.exiting.opacity,
        transition: fadeStyles.entering.transition,
      }}
    >
      {children}
    </div>
  );
}

export default Fade;
